import styled from "styled-components";

export const StyledFeaturedMatch = styled.div`
  width: 100%;
  -webkit-text-size-adjust: 100%;
  margin-top: ${({ theme }) => theme.mixins.pxToRem(theme.figma.base.scale_2)};

  margin-bottom: ${({ theme }) =>
    theme.mixins.pxToRem(theme.figma.base.scale_2)};

  .mls-c-whitebox {
    justify-content: space-between;
    position: relative;

    &.mls-c-featured-match__previous {
      padding: 8px 12px;
      min-height: 60px;
    }
  }
  a {
    width: 100%;
  }

  .mls-c-match-promo {
    margin-top: 10px;

    .mls-c-match-promo__promo-link-button {
      margin-top: 12px;
    }
  }

  .mls-c-match-promo__support {
    margin: 12px auto 0;
  }

  .mls-c-match-promo__support-compact {
    margin: 12px auto 0;
  }

  .mls-c-blockheader__subtitle {
    text-transform: capitalize;
  }

  .mls-c-venue-broadcaster-bar-wrapper {
    justify-content: center;
  }

  .mls-c-venue-broadcaster-bar.--single-broadcaster {
    margin-top: 16px;
    margin-bottom: 16px;
  }

  &.xs,
  &.xxs,
  &.sm {
    .mls-c-venue-broadcaster-bar.--single-broadcaster {
      margin-top: 24px;
      margin-bottom: 16px;
    }
    .mls-c-venue-broadcaster-bar-wrapper {
      flex-direction: column;
      margin-top: 24px;
      margin-bottom: 16px;

      .mls-c-venue-broadcaster-bar__dot {
        display: none;
      }
    }
    &.--compact {
      .mls-c-featured-match {
        .mls-c-club {
          &.--away,
          &.--home {
            max-width: 110px;
          }
        }
      }

      .mls-c-featured-match.--mobile {
        .mls-c-match-tile {
          padding: 0px;

          .mls-c-club {
            &.--away {
              margin-left: 4px;

              .mls-c-club__picture {
                margin-right: 0;
              }
            }

            &.--home {
              margin-right: 4px;

              .mls-c-club__picture {
                margin-left: 0;
              }
            }
          }
        }
      }
    }
  }

  &.xxs {
    .mls-c-match-promo {
      width: auto;

      .mls-c-match-promo__promo-link-button {
        width: 100%;
      }
    }
    .mls-c-match-promo__support {
      width: 100%;
    }
  }

  &.--compact {
    .mls-c-featured-match {
      .mls-c-match-tile-wrapper {
        align-items: center;
        margin-top: 8px;
      }

      .mls-c-status-stamp__status.-post {
        display: none;
      }

      .mls-c-match-tile {
        justify-content: center;
      }

      .mls-c-venue-broadcaster-bar-wrapper {
        margin-top: 8px;
        margin-bottom: 8px;
      }

      .mls-c-scorebug {
        width: 62px;
        height: 30px;
      }

      .mls-c-match-tile {
        .mls-c-club {
          .mls-c-club__shortname,
          .mls-c-club__abbreviation {
            font-size: ${({ theme }) =>
              theme.mixins.pxToRem(theme.figma.base.scale_2_50)};

            line-height: ${({ theme }) =>
              theme.mixins.pxToRem(theme.figma.base.scale_2_50)};
          }

          .mls-c-club__abbreviation {
            width: auto;
          }

          &.--home {
            justify-content: flex-start;
            min-height: 46px;
            flex-direction: row-reverse;
            max-width: 200px;

            .mls-c-club__abbreviation {
              display: block;
              margin-right: 4px;
            }

            .mls-c-club__picture {
              margin-left: 5px;
            }
          }

          &.--away {
            justify-content: flex-start;
            min-height: 46px;
            flex-direction: row;
            max-width: 200px;

            .mls-c-club__abbreviation {
              display: block;
              margin-left: 4px;
            }

            .mls-c-club__picture {
              margin-right: 5px;
            }
          }

          .mls-c-club__picture {
            width: 32px;
          }
        }
      }

      .mls-c-status-stamp__status.-live {
        position: relative;
      }

      .mls-c-scorebug {
        padding-bottom: 0px;

        &.mls-c-scorebug--horizontal {
          transform: none;
        }
      }

      .mls-c-whitebox {
        min-height: 167px;
      }
    }

    &.featuredMatchXxs {
      .mls-c-match-tile {
        .mls-c-club {
          &.--home,
          &.--away {
            .mls-c-club__picture {
              margin-left: 0px;
              margin-right: 0px;
            }
          }
        }
      }

      .mls-c-venue-broadcaster-bar {
        margin: 8px 0;
      }
    }
  }
`;

export const StyledFeaturedMatchHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(221, 221, 221, 1);
  padding-bottom: 10px;
`;

export const StyledSponsorWrapper = styled.div`
  width: 46px;
  height: 28px;
  margin-left: auto;
  z-index: 1;
`;
